import styled from "styled-components";

export const VerOrdenDigitalLaboratorioHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--color-latex30);
  width: 100%;
  height: 48px;
  border-radius: 8px 8px 0 0;
  .cruz-ordenDigital {
    right: 32px;
    top: 16px;
    position: absolute;
    display: block;
    height: 16px;
    width: 16px;
  }
  .cruz-ordenDigital:hover {
    cursor: pointer;
  }
  .cruzParte1-ordenDigital {
    border: 1px solid #fff;
    height: 20px;
    transform: rotate(45deg);
    width: 0px;
    background: #fff;
    position: absolute;
    left: 8px;
  }
  .cruzParte2-ordenDigital {
    border: 1px solid #fff;
    height: 20px;
    transform: rotate(-45deg);
    width: 0px;
    background: #fff;
    position: absolute;
    left: 8px;
  }
`;
export const VerOrdenDigitalLaboratorioContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
export const VerOrdenDigitalLaboratorioBody = styled.div`
  .ptur-pdfOrdenDigital {
    width: 800px;
    height: 600px;
    @media (max-width: 768px) {
      width: 360px;
      height: 500px;
    }
  }
  @media (max-width: 768px) {
    width: 360px;
    height: 500px;
  }
`;
export const VerOrdenDigitalLaboratorioBotones = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
`;
